import dispatcher from 'js/core/dispatcher';
import { setUserInfo_v1 } from 'js/library/utils/API/setUserInfo_v1';
import { createUserInfo } from 'js/library/utils/API/getUserInfo_v1';

export const userFormAction = (
  dispatch,
  aliasName,
  cellPhone,
  optin1,
  optin2
) => {
  //buscando usuário com cpf
  createUserInfo(cellPhone).then((reply) => {
    const uId = reply;
    let fullAddress = {};

    //tratamento optinList
    const currentDate = new Date().getTime();
    const optInList = [
      {
        type: 'Termos de Uso da Triibo',
        optInId: '-Kzj_F6wDcfHkLMO_q4c',
        version: 1.0,
        dateAcceptance: currentDate,
        accept: optin1,
      },
      {
        type: 'Optin - Termos de consentimento de comunicações opcionais',
        optInId: '-KzjMOHvzce-PUYpoWHU',
        version: 1.0,
        dateAcceptance: currentDate,
        accept: optin2,
      },
    ];

    const userInfo = {
      updateDate: new Date().getTime(),
      aliasName: aliasName,
      optInList: optInList,
      addressList: [fullAddress],
      contactList: [
        {
          type: 'cellPhone',
          value: cellPhone,
          verified: false,
        },
      ],
    };

    return dispatcher(
      dispatch,
      'USER_FORM',
      setUserInfo_v1(
        uId,
        ['setUserInfo'],
        userInfo,
        document.location.origin + ''
      )
    );
  });
};
